export const rangeToGranularity = {
    "1w": "daily",
    "1m": "weekly",
    "3m": "weekly",
    "6m": "monthly",
    "1y": "monthly",
    this_month: "weekly", // default
  };
  
  export function getGranularity(range) {
    return rangeToGranularity[range] || "weekly";
  }
  